import { z } from 'zod';
import { schemaSuiviPublic } from './portail-public';
export const ETATS_RECLAMATION_RESEAU = {
  RECEIVED: 'Reçue',
  IN_REVIEW: 'En cours de traitement',
  PENDING_VALIDATION: 'Réponse en cours de validation',
  ANSWERED: 'Réponse disponible',
} as const;
export const schemaReclamationPublique = schemaSuiviPublic
  .extend({
    contenu: z.string().trim().min(10).max(2000),
  })
  .strict();
export const schemaActionReclamationReseau = z
  .object({
    action: z.enum(['prendre_en_charge', 'proposer_reponse', 'rejeter_reponse', 'valider_reponse']),
    version: z.number().int().positive(),
    motif: z.string().trim().min(3).max(500),
    reponse: z.string().trim().max(4000).default(''),
  })
  .strict()
  .superRefine((d, c) => {
    if (d.action === 'proposer_reponse' && d.reponse.length < 10)
      c.addIssue({
        code: 'custom',
        path: ['reponse'],
        message: 'Réponse de 10 caractères au moins requise',
      });
    if (d.action !== 'proposer_reponse' && d.reponse)
      c.addIssue({
        code: 'custom',
        path: ['reponse'],
        message: 'La validation ne peut pas modifier la réponse',
      });
  });
